export default "__VITE_ASSET__DTedxy4b__"